import React from 'react';
import PropTypes from 'prop-types';

import WarningModal from './WarningModal';
import { ModalProps } from 'global/types';

const BASE_KEY = 'app.dialog.delete_list';

export default function CannotDeleteListModal(props: ModalProps) {
  const { modalOptions: { length } } = props;

  return (
    <WarningModal
      {...props}
      displayName="CannotDeleteList"
      header={`${BASE_KEY}.cannot_delete_message`}
      content={{
        id: `${BASE_KEY}.cannot_delete_lower_section`,
        values: { length },
      }}
    />
  );
}

CannotDeleteListModal.propTypes = {
  modalOptions: PropTypes.shape({
    length: PropTypes.number,
  }).isRequired,
};
